import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useComparison } from "../contexts/ComparisonContext";
import { useI18n } from "../contexts/I18nContext";
import { Scale, X } from "lucide-react";

/**
 * Floating "Compare (N/MAX)" pill bottom-right. Hidden on admin/owner/comparator page itself.
 */
export default function ComparisonBar() {
  const { ids, clear, max } = useComparison();
  const { lang } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname || "";
  if (path.startsWith("/admin") || path.startsWith("/owner") || path.startsWith("/login") || path.startsWith("/comparator")) return null;
  if (!ids.length) return null;

  const goCompare = () => {
    if (ids.length < 2) return;
    navigate(`/comparator?ids=${ids.join(",")}`);
  };

  return (
    <div
      className="fixed bottom-4 right-4 z-40 flex items-center gap-2 card-surface px-4 py-3 shadow-2xl"
      style={{ borderColor: "var(--brand-primary)", borderWidth: 1 }}
      data-testid="comparison-bar"
    >
      <Scale className="w-4 h-4" style={{ color: "var(--brand-primary)" }} />
      <span className="text-sm font-medium" data-testid="comparison-bar-count">
        {lang === "en" ? "Compare" : "Compara"}: <b>{ids.length}</b>/{max}
      </span>
      <button
        onClick={goCompare}
        disabled={ids.length < 2}
        className="btn-gold-filled text-xs ml-2"
        data-testid="comparison-bar-go"
      >
        {lang === "en" ? "View" : "Vezi"} →
      </button>
      <button
        onClick={clear}
        className="btn-ghost p-1"
        title={lang === "en" ? "Clear" : "Goleste"}
        data-testid="comparison-bar-clear"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
